import { toast } from 'sonner';
import { Pencil, Check } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { formatNoteSchedule } from '../lib/calendarDates';
import { noteNeedsReview } from '../lib/noteReview';

export function showSavedCapture(batch, { onEdit, onUndo }, organizing = false) {
  const count = batch.notes.length;
  const review = batch.needsReview || batch.notes.some(noteNeedsReview);
  const first = batch.notes[0];
  const summary = organizing ? 'Organizing in the background…' : review ? 'Saved for optional review' : count > 1 ? 'Each item has its own type and schedule.' : [first?.category, formatNoteSchedule(first)].filter(Boolean).join(' · ');
  toast.success(<span data-testid={`capture-saved-title-${batch.original.id}`}>{count > 1 && !batch.needsReview ? `${count} items saved` : 'Saved'}</span>, {
    id: `capture-saved-${batch.original.id}`,
    duration: 6500,
    className: 'capture-saved-toast',
    description: <span data-testid={`capture-saved-summary-${batch.original.id}`}>{summary}</span>,
    action: <button className="saved-feedback-action" data-testid={`capture-edit-${batch.original.id}`} onClick={onEdit}>Edit</button>,
    cancel: <button className="saved-feedback-undo" data-testid={`capture-undo-${batch.original.id}`} onClick={onUndo}>Undo</button>,
    onDismiss: () => { batch.closed = true; },
  });
}

export const SavedBatchEditor = ({ editingBatch, setEditingBatch, setEditing }) => {
  return <Dialog open={!!editingBatch} onOpenChange={open => { if (!open) setEditingBatch(null); }}>
    <DialogContent className="tts-dialog" data-testid="saved-batch-dialog">
      <DialogTitle data-testid="saved-batch-title">{editingBatch?.length || 0} items saved</DialogTitle>
      <DialogDescription data-testid="saved-batch-description">Everything is saved. Editing is optional.</DialogDescription>
      <div className="saved-batch-items">{editingBatch?.map(note => <div className="saved-batch-item" key={note.id} data-testid={`batch-item-${note.id}`}>
        <div><p data-testid={`batch-text-${note.id}`}>{note.text}</p><span className="muted-label" data-testid={`batch-meta-${note.id}`}>{note.category}{formatNoteSchedule(note) ? ` · ${formatNoteSchedule(note)}` : ''}{noteNeedsReview(note) ? ' · Optional review' : ''}</span></div>
        <button className="icon-button" title="Edit saved item" aria-label="Edit saved item" data-testid={`batch-edit-${note.id}`} onClick={() => { setEditingBatch(null); setEditing(note); }}><Pencil size={17} /></button>
      </div>)}</div>
      <div className="dialog-actions"><Button className="primary-button" onClick={() => setEditingBatch(null)} data-testid="saved-batch-done"><Check size={16} />Done</Button></div>
    </DialogContent>
  </Dialog>;
};